import DateTimePicker from '../../components/controls/DateTimePicker/DateTimePicker';
import classes from './generate-withdrawal-summary-report-form.module.css';

export interface GenerateWithdrawalSummaryReportFormProps { }

function GenerateWithdrawalSummaryReportForm(props: GenerateWithdrawalSummaryReportFormProps) {

	return (
		<div className='row'>
			<div className="col">
				<DateTimePicker id='startDate' text='Start Date' type='date' />
			</div>
			<div className="col">
				<DateTimePicker id='endDate' text='End Date' type='date' />
			</div>
			<div className="col" style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
				<button className='btn btn-secondary'>Preview...</button>
			</div>
		</div>
	);
}

export default GenerateWithdrawalSummaryReportForm;